module.exports = __webpack_public_path__ + "assets/img/wx-hf.f33d4959.jpg";